import { http, getApiUrl } from './request.js'

// 司机列表
const driverlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/driver/list'), payload);
}

// 新增司机信息
const addDriver = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/driver/save'), payload);
}

// 更新司机信息
const updateDriver = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/driver/update'), payload);
}

// 地址列表
const locationlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/location/list'), payload);
}

// 客户列表
const customerlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/customer/list'), payload);
}

// 新增客户信息
const addCustomerInfo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/customer/save-customerInfo'), payload);
}

// 更新客户信息
const updateCustomerInfo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/customer/update-customerInfo'), payload);
}


// 公司列表
const companyUserlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/company-user/list'), payload);
}

// 用户列表
const userlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/user/list'), payload);
}

// 设置语言
const setLanguage = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/user/set/language'), payload);
}


//货车列表
const trucklist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/truck/list'), payload);
}

//新增货车
const addTruck = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/truck/save'), payload);
}

//更新货车
const updateTruck = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/truck/update'), payload);
}

// 新增工厂地址
const addLocation = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/location/save'), payload)
}

// 修改工厂地址
const updateLocation = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/location/update'), payload)
}

export {
    setLanguage,
    driverlist,
    locationlist,
    customerlist,
    companyUserlist,
    userlist,
    trucklist,
    addTruck,
    addDriver,
    updateTruck,
    updateDriver,
    addLocation,
    updateLocation,
    addCustomerInfo,
    updateCustomerInfo
}